import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'noData',
    pure: false,
    standalone: false
})
export class NoDataPipe implements PipeTransform {

  transform(data: any): string {
    if (typeof data === 'string') {
      data = data.trim();
    }

    if (data == null || data == '') {
      return '-';
    } else {
      return data;
    }
  }
}
